module.exports = __webpack_public_path__ + "img/SN.95524db2.svg";